import { PiStrategy } from "react-icons/pi";
import { PiStrategyBold } from "react-icons/pi";
import { TbTools } from "react-icons/tb";
import { MdOutlineCases } from "react-icons/md";
import { MdPeopleOutline } from "react-icons/md";
import { HiOutlineTrendingUp } from "react-icons/hi";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import React from "react";
import { Link } from "react-scroll";
import { FaArrowRightLong } from "react-icons/fa6";
import AdvantListIcon from "../../img/advant-list-icon.svg";

function AdvantagesOne({ advantagesData }) {

    const styles = "border border-gray-200 p-6 rounded-lg h-full relative overflow-hidden";

    return (
        advantagesData ?
            <section className="mb-10">
                <div className="container mx-auto p-4 sm:p-0">
                    <div className="relative overflow-hidden flex flex-col md:flex-row md:gap-8 bg-[#F5F5F7] rounded-[26px] pt-[60px] pb-[60px] pr-[15px] pl-[15px]
                sm:pt-[80px] sm:pb-[80px] sm:pr-[40px] sm:pl-[55px]
                lg:pt-[110px] lg:pb-[110px] lg:pr-[63px] lg:pl-[85px] mb-16 md:mb-32">

                        <div className="md:w-1/2 mb-6 md:mb-0">
                            <ScrollAnimation animateIn="animate__fadeInUp">
                                <h2 className="text-3xl  lg:text-[52px] lg:leading-[120%] mb-4 lg:mb-14 uppercase max-w-[510px]">
                                    {advantagesData.advantages_title}
                                </h2>
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="animate__fadeInUp">
                                <img src={advantagesData.advantages_img} alt=""
                                    className="hidden md:block z-10 relative rounded-[26px] w-full max-w-[498px]" />
                            </ScrollAnimation>

                            <div className="hidden md:block absolute bottom-[-130px] left-[-47px] w-[415px] h-[415px] 
                                rounded-full bg-[linear-gradient(59deg,#AED8FF_0%,#D5F3FF_39.42%,#F0ECFF_75%)] blur-[100px]">
                            </div>
                        </div>

                        <div className="md:w-1/2">
                            <ul>
                                {advantagesData.advantages_repeater
                                    ? advantagesData.advantages_repeater.map((item, index) => (
                                        <li key={index}
                                            className="text-xl flex items-center gap-4 md:gap-7 lg:gap-10 py-[18px] py-[26px] first:pt-0 border-b border-[#BEBDBD]"
                                        >
                                            <img
                                                src={AdvantListIcon}
                                                alt="icon"
                                                className="shrink-0 w-[30px] md:w-[45px]"
                                            />
                                            <span>{item.advantages_repeater_text}</span>
                                        </li>
                                    ))
                                    : ""}
                            </ul>
                            {
                                /*
                                <div className="sm:order-0">
                                    <ScrollAnimation animateIn="animate__fadeInUp h-full">
                                        <p className="text-[18px] mb-4">{advantagesData.advantages_absaz[1].advantages_absaz_text}</p>
                                        <Link to="formats" className="text-[#003366] uppercase font-bold flex items-center gap-2" smooth={true} offset={-70} duration={500}>Взяти участь <FaArrowRightLong /></Link>
                                    </ScrollAnimation>
                                    </div>*/
                            }
                        </div>
                    </div>
                </div>
            </section> : ''
    )

}


export default AdvantagesOne